module.exports = __webpack_public_path__ + "static/img/3.e498596.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zhongzaisheng/detail2/3.png
// module id = XP9L
// module chunks = 19